<template>
  <div class="contact-us">
    <nav-bar :main-index="0"></nav-bar>
    <div class="change">
      <img
        alt
        class="aboutUsImg wow bounceInLeft"
        data-wow-duration="1500ms"
        src="../assets/images/aboutUs.png"
      />
      <div class="totalAmount">
        <div>总交易额（人民币）</div>
        <vns :end="45000" :format="num => num + '亿 +'" :speed="20" :start="0" :times="50" />
      </div>
      <!-- <img alt="" class="daLogoImg wow bounceInRight" data-wow-duration="2s" src="../assets/images/daLogo.png"> -->
    </div>

    <!-- <div class="aboutUs">
     直达软件是一家“为交易而生”的科技金融公司，总部位于中国上海，2011年成立。直达软件聚焦金融行业，提供期货，证券交易整体解决方案和服务。
      <br />直达持续赋能金融机构创新发展，为客户极致交易体验而不断努力创造。 
    </div>-->
    <div class="sloganBox">
      <div>
        <div>我们的使命</div>
        <div>为交易而生！</div>
      </div>
      <div>
        <div>我们的愿景</div>
        <div>通过科技创新来重新定义和改造金融业，打造人人乐享的投资体验。</div>
      </div>
      <div>
        <div>我们的价值观</div>
        <div>专注、极致、口碑、快</div>
      </div>
    </div>
    <!-- <div class="timerBox">
        <span class="point point1 point-flicker">
          <span>
            2011.1
            <br />直达软件成立
          </span>
        </span>
        <span class="point point2" v-if="!pointTwo" style="background: none">
          <span>
            2011.9
            <br />期货交易系统上线
          </span>
        </span>
        <span class="point point2 point-flicker" v-else>
          <span>
            2011.9
            <br />期货交易系统上线
          </span>
        </span>
        <span class="point point3" v-if="!pointThree" style="background: none">
          <span>
            2014.3
            <br />中美低延迟交易线路上线
          </span>
        </span>
        <span class="point point3 point-flicker" v-else>
          <span>
            2014.3
            <br />中美低延迟交易线路上线
          </span>
        </span>
        <span class="point point4" v-if="!pointFour" style="background: none">
          <span>
            2017.6
            <br />证券交易系统上线
          </span>
        </span>
        <span class="point point4 point-flicker" v-else>
          <span>
            2017.6
            <br />证券交易系统上线
          </span>
        </span>
        <span class="point point6" v-if="!pointFive" style="background: none">
          <span>
            2020.6
            <br />证券期货一体化交易系统上线
          </span>
        </span>
        <span class="point point6 point-flicker" v-else>
          <span>
            2020.6
            <br />证券期货一体化交易系统上线
          </span>
        </span>
        <span class="point point5" v-if="!pointSix" style="background: none">
          <span>
            2018.9
            <br />清算系统上线
          </span>
        </span>
        <span class="point point5 point-flicker" v-else>
          <span>
            2018.9
            <br />清算系统上线
          </span>
        </span>

        <img alt="直达软件" class="hiddenImg" src="../assets/images/timeShaft.png" />
    </div>-->
    <div class="certificate">
      <h3>我们的成果</h3>
      <dl>
        <dd class="wow slideInRight" data-wow-duration="500ms" offet="0">
          <h4>2011</h4>
          <p>直达软件成立</p>
          <p>期货交易系统上线</p>
        </dd>
        <dd class="wow slideInLeft" data-wow-duration="1000ms" offet="0">
          <h4>2014</h4>
          <p>中美低延迟交易线路上线</p>
        </dd>
        <dd class="wow slideInRight" data-wow-duration="1500ms" offet="0">
          <h4>2015</h4>
          <h5>直达软件著作权颁发：</h5>
          <p>直达柜台数据维护软件</p>
          <p>直达鼎赢期货软件</p>
          <p>直达speedy程序化期货交易软件</p>
        </dd>
        <dd class="wow slideInLeft" data-wow-duration="1250ms" offet="0">
          <h4>2016</h4>
          <p>软件产品证书颁发</p>
        </dd>
        <dd class="wow slideInRight" data-wow-duration="1500ms" offet="0">
          <h4>2017</h4>
          <p>软件企业证书颁发</p>
        </dd>
        <dd class="wow slideInLeft" data-wow-duration="1250ms" offet="0">
          <h4>2018</h4>
          <p>清算系统上线</p>
        </dd>
        <dd class="wow slideInRight" data-wow-duration="1250ms" offet="0">
          <h4>2019</h4>
          <h5 style="padding-bottom: 20px">高新技术企业证书颁发</h5>
          <h5>直达软件著作权颁发：</h5>
          <p>股票期货二合一API接口</p>
          <p>全球市场清算系统</p>
          <p>期货，股票Dealer交易软件</p>
          <p>股票期货在线开户系统</p>
          <p>期货资管交易系统</p>
          <p>全球期货市场套利交易系统</p>
        </dd>
        <dd class="wow slideInLeft" data-wow-duration="1250ms" offet="0">
          <h4>2020</h4>
          <p>证券期货一体化交易系统上线</p>
        </dd>
        <dd class="wow slideInRight" data-wow-duration="1500ms" offet="0">
          <h4>2021</h4>
          <p>直达国际APP软件著作权</p>
        </dd>
      </dl>
      <dt>以上所有证书由相关部门批准：中华人民共和国国家版权局，上海市科学技术委员会，上海市财务局，国家税务总局上海市税务局，上海市软件行业协会</dt>
    </div>

    <div class="footer">
      <div class="info">
        <div>电话：021-26067401 &nbsp;&nbsp;&nbsp;&nbsp;9:00 ～ 18:00</div>
        <div>邮箱：services@directaccess.cn</div>
      </div>
      <div class="position">
        <div style="width: 417px;">办公地址：上海市浦东新区樱花路建工大唐国际广场A栋3楼</div>
      </div>
    </div>
  </div>
</template>

<script>
import navBar from "../components/navBar";
import vns from "vue-number-scroll";

export default {
  name: "contactUs",
  data() {
    return {
      pointTwo: false,
      pointThree: false,
      pointFour: false,
      pointFive: false,
      pointSix: false
    };
  },
  components: {
    navBar: navBar,
    vns: vns
  },
  mounted() {
    this.$nextTick(() => {
      new this.$wow.WOW().init();
    });
  },
  methods: {}
};
</script>

<style scoped>
.contact-us {
  background: url('../assets/images/contactUsBg.png') 0 78px;
  background-size: 100%;
}
.aboutUsImg {
  z-index: 999;
  position: relative;
}

.daLogoImg {
  width: 431px;
  height: 55px;
  position: absolute;
  left: 434px;
  top: 234px;
}

.aboutUs {
  display: inline-block;
  margin-left: 134px;
  width: 960px;
  margin-top: 38px;
  font-size: 26px;
  font-family: Lantinghei SC;
  font-weight: 200;
  color: #ffffff;
  line-height: 48px;
}

.totalAmount {
  float: right;
  position: relative;
}

.totalAmount :first-child {
  font-family: Lantinghei SC;
  font-weight: 600;
  color: #ffffff;
}

.totalAmount :last-child {
  font-family: Lantinghei SC;
  font-weight: bold;
  color: #ffa63e;
}

.timerContent {
  width: 1768px;
  /* height: 872px; */
  background: #1f293b;
  opacity: 0.9;
  margin: 80px auto 64px;
}

.timerBox {
  width: 1602px;
  height: 336px;
  margin: 113px auto;
  background-image: url("../assets/images/timeShaft.png");
  background-repeat: no-repeat;
  position: relative;
}

.sloganBox {
  display: flex;
  margin-top: 83px;
}

.sloganBox > div {
  flex: 1;
  margin-left: 5%;
  padding-bottom: 83px;
}

.sloganBox > div :first-child {
  font-family: Lantinghei SC;
  font-weight: bold;
  color: #ffa63e;
}

.sloganBox > div :last-child {
  font-family: Lantinghei SC;
  font-weight: 300;
  color: #ffffff;
}

.certificate {
  width: 95%;
  margin: 0 auto;
  text-align: center;
  background: url("../assets/images/certificate_bg.png") center bottom;
  background-size: 100% 100%;
}

.certificate h3 {
  font-family: Lantinghei SC;
  font-weight: 600;
  color: #ffa63e;
}

.certificate dl {
  position: relative;
}

.certificate dl::after {
  content: "";
  position: absolute;
  width: 1px;
  height: 95%;
  background: #ff9000;
}

.certificate dl dd {
  margin: 0 auto;
  text-align: left;
}

.certificate dl dd h4 {
  font-family: Lantinghei SC;
  font-style: italic;
  color: #ff9000;
}
.certificate dl dd:nth-child(1n) {
  position: relative;
}

.certificate dl dd:nth-child(2n) {
  position: relative;
}

.certificate dl dd:nth-child(1n)::before {
  position: absolute;
  content: "";
  background: #ff9000;
  border-radius: 50%;
}

.certificate dl dd:nth-child(2n)::before {
  position: absolute;
  content: "";
  background: #ff9000;
  border-radius: 50%;
}

.certificate dl dd p {
  font-family: Lantinghei SC;
  position: relative;
}

.certificate dl dd h5 {
  font-family: Lantinghei SC;
  position: relative;
}

.certificate dl dd p::before {
  position: absolute;
  content: "";
  background: #ff9000;
  border-radius: 50%;
}

.footer {
  display: flex;
}

.footer > div {
  flex: 1;
  display: inline-block;
  font-family: Lantinghei SC;
  font-weight: 200;
  color: #ffffff;
}

.info {
  margin-left: 20%;
  margin-right: 10%;
  position: relative;
}

.info :first-child:after {
  content: "";
  background: url("../assets/images/shezhi.png");
  position: absolute;
  background-size: 100% 100%;
  position: absolute;
}

.position {
  position: relative;
}

.position :first-child:after {
  content: "";
  background: url("../assets/images/dizhi.png");
  position: absolute;
  background-size: 100% 100%;
}

.point {
  position: absolute;
  display: inline-block;
  width: 27px;
  height: 27px;
  background: #ff9000;
  border-radius: 50%;
}

/* 设置动画前颜色 */
.point-flicker:after {
  background-color: #ff9000;
}

/* 设置动画后颜色 */
.point-flicker:before {
  background-color: #fff;
}

/* 设置动画 */
.point-flicker:before,
.point-flicker:after {
  content: "";
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -20px;
  margin-top: -20px;
  border-radius: 50%;
  animation: warn 1.5s ease-out 0s infinite;
}

/* @keyframes 规则用于创建动画。在 @keyframes 中规定某项 CSS 样式，就能创建由当前样式逐渐改为新样式的动画效果。 */
@keyframes warn {
  0% {
    transform: scale(0.5);
    opacity: 1;
  }

  30% {
    opacity: 1;
  }

  100% {
    transform: scale(1.4);
    opacity: 0;
  }
}

.point > span {
  position: absolute;
  display: inline-block;
  font-size: 30px;
  font-family: Lantinghei SC;
  font-weight: 200;
  color: #ffffff;
  line-height: 48px;
  border-radius: 5px;
}

.point1 {
  bottom: -3px;
  left: -2px;
}

.point1 :first-child {
  width: 190px;
  top: -116px;
}

.point2 {
  bottom: 45px;
  left: 347px;
}

.point2 :first-child {
  width: 240px;
  top: 35px;
  left: 24px;
}

.point3 {
  bottom: 144px;
  left: 570px;
}

.point3 :first-child {
  width: 180px;
  top: -140px;
  left: -141px;
}

.point4 {
  bottom: 176px;
  left: 920px;
}

.point4 :first-child {
  width: 313px;
  top: -124px;
  left: -130px;
}

.point5 {
  bottom: 244px;
  left: 1277px;
}

.point5 :first-child {
  width: 210px;
  top: 49px;
  left: -28px;
}

.point6 {
  bottom: 310px;
  left: 1459px;
}

.point6 :first-child {
  width: 280px;
  top: -125px;
  left: -150px;
}
</style>



// WEBPACK FOOTER //
// src/components/contactUs.vue